<template>
  <div id="app">
    <div class="toggle-button"
      v-bind:class="{ clicked : toggle }"
      v-on:click="toggle = !toggle">
      <span class="first"></span>
      <span class="second"></span>
      <span class="third"></span>
    </div>
    <nav>
      <a href="/" id="logo">Kate Mack</a>
      <div id="nav" v-bind:class="{ opened : toggle }" >
        <router-link to="/" v-on:click.native="toggle = false">Home</router-link>
        <div class="dropdown" v-on:click.native="hover = true; show_collection = true" @mouseover="hover = true; show_collection = true">Collections</div>
        <transition name="collections-transition">
          <div class="nav-collections" v-bind:class="{show_collection: show_collection}" @mouseover="hover = true" @mouseleave="hover = false; show_collection = false" v-on:click="toggle = false; show_collection = false">
            <router-link to="/group-collection/winter-style" v-on:click.native="toggle = false">Winter Style</router-link>
            <router-link to="/group-collection/summer-style" v-on:click.native="toggle = false">Summer Style</router-link>
            <router-link to="/group-collection/resort" v-on:click.native="toggle = false">Resort</router-link>
            <router-link to="/collection/home-wellness" v-on:click.native="toggle = false">Home & Wellness</router-link>
            <router-link to="/collection/Goodies" v-on:click.native="toggle = false">Goodies</router-link>
            <router-link to="/collection/katemack-for-male" v-on:click.native="toggle = false">Katemack for Male</router-link>
          </div>
        </transition>
        <router-link to="/bio" v-on:click.native="toggle = false">Bio</router-link>
        <router-link to="/press" v-on:click.native="toggle = false">Press</router-link>
        <a href="https://shop.kate-mack.com">Shop</a>
        <router-link to="/contact" v-on:click.native="toggle = false">Contact</router-link>
      </div>
    </nav>
    <main>
      <router-view/>
    </main>
    <footer>
      <div class="social">
        <a href="https://www.facebook.com/kate.mackofficiel" target="_blank" rel="nofollow">
          <img src="@/assets/images/iconfinder_Rounded_Facebook_svg_5282541.svg" alt="Facebook icon">
        </a>
        <a href="https://www.instagram.com/_katemack_/" target="_blank" rel="nofollow">
          <img src="@/assets/images/iconfinder_Rounded_Instagram_svg_5282544.svg" alt="Instagram icon">
        </a>
        <a href="https://twitter.com/katekatemack" target="_blank" rel="nofollow">
          <img src="@/assets/images/iconfinder_Rounded_Twitter5_svg_5282551.svg" alt="Twitter icon">
        </a>
        <!--
          <div>Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>
         -->
      </div>
      <div class="text">
        KATE MACK. ALL ABOUT FASHION, FASHION, FASHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHION ...AND MORE!
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Kate Mack',
    // all titles will be injected into this template
    titleTemplate: null,
    description: 'Kate Mack Website',
    meta: [
      { charset: 'utf-8' },
      { 
        name: 'keywords',
        content: 'kate-mack, Kate, Mack, kate mack, Wearable Art Dealer, art, fashion, Local Designer, Small business, Designer, Artisan, Artisan Designer'
      },
      {
        property: 'og:title',
        content: 'Kate Mack',
        template: chunk => `${chunk} - Home`,
        vmid: 'og:title'
      },
      {
        property: 'og:url',
        content: 'https://kate-mack.com',
        vmid: 'og:url'
      }
    ]
  },
  data: function() {
    return {
      toggle : false,
      collection_menu : false,
      hover : false,
      show_collection: false
    }
  },
  watch: {
    toggle: function() {
      document.querySelector("html").classList.toggle("opened");
    }
  }
}
</script>

<style lang="scss">
html, body {
  width: 100%;
  padding: 0;
  margin: 0;
  height: 100vh;
  &.opened {
    overflow-y: hidden;
  }
}

* {
  background-color: #000;
  color: #dcdcdc;
  box-sizing: border-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

$square: 50px;

div.toggle-button {
  position: fixed;
  top: 1rem;
  left: 1rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  height: $square;
  width: $square;
  border: 1px solid #dcdcdc;
  z-index: 99;
  span {
    display: block;
    width: 85%;
    height: 3px;
    background: #dcdcdc;
    border-radius: 0.2em;
    transition: all 0.5s;
  }
  &.clicked {
    background-color: #dcdcdc;
    span {
      background: #000;
    }
    span.first {
      transform: translateY(calc(#{$square} / 3 - 4px)) rotate(-135deg);
    }
    span.third {
      transform: translateY(calc(-1*(#{$square} / 3 - 4px))) rotate(135deg);
    }
    span.second {
      transform: rotate(315deg);
    }

  }
}

nav {
  *:focus {
    outline: none;
  }
  display: flex;
  justify-content: center;
  min-height: 80px;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #fff;
  div#nav > a, div#nav > div.dropdown {
    &:focus {
      outline: none;
    }
    display: flex;
    //justify-content: center;
    flex-direction: column;
    align-items: center;
     &:after {
        transition: width 0.5s ease;
        content: '';
        display: block;
        width: 0%;
        height: 2px;
        margin-top: 2px;
        //padding: 0.5rem;
        background-color: white;
      }
    &:hover, &.router-link-exact-active {
     &:after {
        width: 100%;
      }
    }
  }
  a, div#nav > div {
    text-decoration: none;
    &#logo {
      font-size: 2rem;
      justify-self: flex-start;
      text-transform: uppercase;
      margin: {
        left: 2rem;
        right: 1rem;
      }
    }
    margin: {
      top: 1rem;
      bottom: 1rem;
      left: 0rem;
      right: 0rem;
    }
  }
  div.dropdown {
    cursor: pointer;
  }
  div.nav-collections {
    transition-delay: 1s;
    visibility: hidden;
    opacity: 0;
    width: 100%;
    background-color: rgba($color: #191919, $alpha: .8);
    position: fixed;
    top: 80px;
    left: 0px;
    padding: 10px;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    a {
      padding: 0.5rem;
      background-color: transparent;
      user-select: none;
      border: solid 0.1rem white;
      border-radius: 5px;
      margin: 0.5rem;
      padding: 0.4rem;
      &:hover {
        cursor: pointer;
        color: black;
        background-color: white;
        border-color: black;
      }
    }
  }
  .show_collection {
    transition-delay: .8s !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  div#nav {
    display: none;
    z-index: 1;
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &.opened {
      display: flex;
    }
  }
}

footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #fff;
  width: 100%;
  height: 60px;
  font-size: 60%;
  div.social {
    display: flex;
    padding: {
      left: 2rem;
      right: 2rem;
    }
    img {
      height: 35px;
      width: auto;
      height: 2.5rem;
      width: 2.5rem;
      padding: {
        left: 0.3rem;
        right: 0.3rem;
      }
    }
  }
  div.text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 0.5rem;
  }
}
main {
  flex: 1;
  width: 100%;
}

.collections-transition-enter-active {
  transition-delay: 5s;
}

@media screen and (min-width: 600px) {
  div.toggle-button {
    display: none;
  }
  nav {
    div#nav {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      flex: 1;
      flex-direction: row;
      a, div {
        margin: {
          top: 0rem;
          bottom: 0rem;
          left: 0.8rem;
          right: 0.8rem;
        }
      }
    }
    div.nav-collections {
      transition-delay: 0.1s;
      position: fixed;
      top: 80px;
      left: 0px;
      height: 150px;
      flex-direction: row;
    }
    .show_collection {
      transition-delay: 0.1s !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
  }
  footer {
    flex-direction: row;
    font-size: 100%;
    min-height: 60px;
    div.text {
      padding-bottom: 0;
    }
  }
}
</style>
